import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import NameTag from './NameTag';
/**
 * Name Tag Group is a type of **molecule** that represent users by rectangular name tags
 */
const NameTagGroup = ({ className, users, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    const indicatorBackgroundColors = [
        'bg-real-time-collaboration-blue',
        'bg-real-time-collaboration-red',
        'bg-real-time-collaboration-purple',
        'bg-real-time-collaboration-green',
    ];
    return (_jsx("ol", { className: buildClassName('skyline-text-caption-2 m-auto flex flex-col pl-0 leading-6', className), ...dataAttributes, children: users.map((user, index) => (_jsx("li", { className: "list-none", children: _jsx(NameTag, { firstName: user.firstName, lastName: user.lastName, className: buildClassName(indicatorBackgroundColors[index % indicatorBackgroundColors.length], 'w-fit') }) }, user.id ?? index))) }));
};
export default NameTagGroup;
//# sourceMappingURL=NameTagGroup.js.map